export default __webpack_public_path__ + "29f2d4a36bf75c99562769ae801a6c59.woff2";